/**
 * Get speaker from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'
import BS_OBJECT_TYPES from './objectTypeIds'

const SEARCH_PAGE_ID = '/dosearch'

const stringifyAsArray = (item) => {
  if (Array.isArray(item)) {
    return JSON.stringify(item)
  }
  return `[${JSON.stringify(item)}]`
}

export const speakersGQLQuery = () => {
  const imageHeight = getIsLowBandwidth() ? 250 : 360
  const imageWidth = getIsLowBandwidth() ? 250 : 500
  return gql(`
    {
      RootsTechPageEntry(id: "/speakers") {
        ... on SpeakersPage {
          description
          title
          keynoteSpeakers {
            title
            url
            type
            contentUUID
            description
            image {
              custom(height: ${imageHeight}, width: ${imageWidth}, crop:true) {
              image {
                src
              }
            }
            }
          }
        }
      }
    }
  `)
}

export const speakerSearchGQLQuery = ({ query, searchLocale }) => {
  const imageHeight = getIsLowBandwidth() ? 250 : 360
  const imageWidth = getIsLowBandwidth() ? 250 : 500
  return gql(`query Pagination ($page: Int = 1) {
      RootsTechSearchPage(id: "${SEARCH_PAGE_ID}" page: $page, languages:${stringifyAsArray(searchLocale)} types: ["${
    BS_OBJECT_TYPES.CREATOR
  }"], query: ${JSON.stringify(query)} ) {
        nextPage
        results {
          url
          title
          contentUUID
          image {
            custom(height: ${imageHeight}, width: ${imageWidth}, crop:true) {
              image {
                src
              }
            }
          }
        }
      }
    }
  `)
}

export const dummy = () => {}
